module.exports = __webpack_public_path__ + "img/about-icon-02.4361c4f2.svg";